import { render, staticRenderFns } from "./WidgetCrmTopAgent.vue?vue&type=template&id=1845a410"
import script from "./WidgetCrmTopAgent.vue?vue&type=script&lang=js"
export * from "./WidgetCrmTopAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports